import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Collapse, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { MaterialItem } from './MaterialItem';
import IconEstado from '../UI/IconEstado';
import { AUTORIZACIONES_SOLICITUDES_ESTADOS, TIPOS_AUTORIZACIONES } from '../../../utils/constants';
import { MaterialItemCompras } from '../../Compras/Materiales/MaterialItemCompras';

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
    backgroundColor: 'lightgray',
  },
});

export const PracticaItem = (props) => {
  const { item, estadoSolicitud, idTipoSolicitud } = props;
  const [open, setOpen] = React.useState(false);
  const classes = useRowStyles();

  const materialesFiltrados = item.materiales.filter(x=>x.fechaBaja === null);
  return (
    <>
      <TableRow className={classes.root}>
        <TableCell component="th" scope="row">
          <IconEstado
            useColorTable={true}
            texto={item?.estadoPracticaSolicitud?.letra}
            backgroundColor={item?.estadoPracticaSolicitud?.color}
            descripcion={item?.estadoPracticaSolicitud?.descripcionEstado}
          />
        </TableCell>
        <TableCell component="th" scope="row">
          {item.practica?.desNom}
        </TableCell>
        <TableCell align="right">{item.cant}</TableCell>
        <TableCell align="center">{item.recuperoSur ? 'SI' : 'NO'}</TableCell>
        <TableCell>
          {item.materiales.length > 0 &&
            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          }
        </TableCell>
        <TableCell>
          {item.cartillaPrestadores?.atiendeCentroPropio
            ? item.cartillaPrestadores?.centroMedicoPropio.descripcionCentro
            : props.idPrestacion
              ? item.efectorProfesional?.nombreApellido
              : item.cartillaPrestadores
                ? item.cartillaPrestadores?.prestador?.nombreApellido
                : item.efectorFacturacion?.nombreFantasia

          }
        </TableCell>
        {(props.conInternacion || props.idPrestacion) &&
          <TableCell>{item.efectorProfesional?.nombreApellido}</TableCell>
        }
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0, paddingLeft: 50 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Materiales
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Estado Material</TableCell>
                    {idTipoSolicitud === TIPOS_AUTORIZACIONES.PRACTICAS_EN_INTERNACION && <TableCell>Estado Compra</TableCell>}
                    <TableCell>Material</TableCell>
                    <TableCell align="right">Cantidad</TableCell>
                    <TableCell align="center">SURGE</TableCell>
                    <TableCell align="center">Disponible</TableCell>

                  </TableRow>
                </TableHead>
                <TableBody>
                  {materialesFiltrados.map((item) => (
                    <MaterialItem key={item?.material?.codigoNum?.toString()} item={item} idTipoSolicitud={idTipoSolicitud} />
                  ))}
                </TableBody>
                <br></br>
              </Table>
            </Box>

            {(estadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_MATERIALES ||
              estadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA) &&

              <Box margin={1}>
                <Typography variant="h6" gutterBottom component="div">
                  Materiales Agregados en Compras
                </Typography>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell>Estado Material</TableCell>
                      <TableCell>Material</TableCell>
                      <TableCell align="right">Cantidad</TableCell>
                      <TableCell align="center">SURGE</TableCell>
                      <TableCell align="center">Disponible</TableCell>
                    </TableRow>
                  </TableHead>
                  {props.materialCotizacion && props.materialCotizacion.cabeceraCotizacion != null &&
                    props.materialCotizacion.cabeceraCotizacion.map((b) => b.detalleCotizaciones.length) !== item.materiales.length ?
                    <TableBody>
                      {props.materialCotizacion.cabeceraCotizacion.map((item) => (
                        item.detalleCotizaciones.map((a) => {
                          if (a.aceptado === true && a.agregadoCompras === true) {
                            return (
                              <MaterialItemCompras key={item?.materiales?.codigoNum?.toString()} item={a} />
                            )
                          }
                          return null
                        })
                      ))}
                    </TableBody>
                    :
                    <TableBody>
                      <TableCell
                        colSpan={13}
                        style={{ textAlign: "-webkit-center" }}
                      >
                        {" "}
                        No se han ingresado materiales en el area de compras.
                      </TableCell>
                    </TableBody>
                  }
                  <br></br>
                </Table>
              </Box>
            }
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}